import React from "react";
import { Route, Redirect } from "react-router-dom";
export function PrivateRoute({ children, ...rest }) {
  const authenticated = localStorage.getItem("login");
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return authenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
}
